// @deprecated — migrate remaining callers (RateLimitingForm) to Modal.footer, then delete this file
import React from 'react';

import { Button } from '@/components/ui/button';

export interface ScanProfileModalFooterProps {
  /** Primary action — right-most. Label, onClick, disabled. */
  primary: {
    label: string;
    onClick: () => void;
    disabled?: boolean;
    'data-testid'?: string;
  };
  /**
   * Cancel action — outlined, sits left of primary.
   * Optional: omit to render no Cancel button.
   */
  cancel?: {
    onClick: () => void;
    disabled?: boolean;
    'data-testid'?: string;
  };
  /**
   * Optional left-side slot — for Delete (override editor) or Skip
   * (assign create mode). Pass a single Button or custom JSX.
   */
  leftSlot?: React.ReactNode;
  /**
   * Optional back action — renders an outline Back button before leftSlot.
   */
  back?: {
    onClick: () => void;
    disabled?: boolean;
    'data-testid'?: string;
  };
}

export const ScanProfileModalFooter: React.FC<ScanProfileModalFooterProps> = ({
  primary,
  cancel,
  leftSlot,
  back,
}) => {
  return (
    <div className="flex items-center justify-between gap-4">
      <div className="flex items-center gap-2">
        {back && (
          <Button
            variant="outline"
            onClick={back.onClick}
            disabled={back.disabled}
            data-testid={back['data-testid']}
          >
            Back
          </Button>
        )}
        {leftSlot ?? <div />}
      </div>
      <div className="flex gap-2">
        {cancel && (
          <Button
            variant="ghost"
            onClick={cancel.onClick}
            disabled={cancel.disabled}
            data-testid={cancel['data-testid']}
          >
            Cancel
          </Button>
        )}
        <Button
          onClick={primary.onClick}
          disabled={primary.disabled}
          data-testid={primary['data-testid']}
        >
          {primary.label}
        </Button>
      </div>
    </div>
  );
};
